export default __webpack_public_path__ + "static/media/banner.3c7c2632.jpg";